import Vue from "vue";
import initService from "./init-service";
import sessionIdDirective from "../directive/sessionId-directive";
import moment from "moment";
import * as Bugsnag from "@bugsnag/js";
import configDirective from "../directive/config-directive";
import ToastVue from "../../views/Components/Toast.vue";

let vm = new Vue({});
let pId = sessionIdDirective.getJSessionId();
let headers = {
	headers: {
		"Content-Type": "application/json",
		"x-api-key": process.env.VUE_APP_CONFIG_APIKEY,
	},
};

function getCustomerInfo() {
	let userName = initService.getUserNameInfo();
	let customer = initService.getCustomerInfo();
	let group = initService.getGroupInfo();
	let carrier = configDirective.getCarrier();
	return {
		userName,
		customer,
		group,
		carrier,
	};
}

//let supportUser = configDirective.getSupportContact();
let i = 0;
const commonService = {
	commonAPI(params, retry = 0, ws_timeout = 90, expireCache = false) {
		if (process.env.NODE_ENV === "dev") {
			console.warn("[DEBUG][commonAPI][params]", params, "[retry]", retry);
		}
		let {userName, customer, group, carrier} = getCustomerInfo();
		if (carrier) customer = carrier;
		let baseUrl = `${process.env.VUE_APP_CONFIG_BASEURL}`;
		//remove undefined
		if (baseUrl.includes("/undefined")) baseUrl = baseUrl.replace("/undefined", "");
		let url = `${baseUrl}?method=${params}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
		//look for authorization for authentication
		if (params.indexOf("&auth=1") > -1) {
			url = `${baseUrl}?method=${params}&customer=Administrator&user=${userName}&group=${group}&pid=${pId}`;
		}
		let param_list = params.split("&");
		let method = param_list[0];
		if (process.env.NODE_ENV === "dev") {
			console.warn("[DEBUG][commonAPI][url]", url);
		}
		//Cache handler
		let cached_methods = [
			// *** statistics *** TOP CARDS AVGS
			"IOT_GetTotalDataVolumesByPeriod",
			"IOT_GetTotalDataSessionsByPeriod",
			"IOT_GetTotalAlertsByPeriod",
			"IOT_GetTotalZeroSessionsByPeriod",
			// *** inventory ***
			"IOT_GetSimInventory",
			// *** map ***
			"IOT_GetDataVolumeSummaryByRegion_map",
			// *** top metrics ***
			"IOT_GetTopMetricsDataVolume",
			"IOT_GetTopMetricsDataSessions",
			"IOT_GetAlerts",
			"IOT_GetTopMetricsZeroSession",
			// *** data graphs ***
			"IOT_GetAverageDataVolumes",
			"IOT_GetDataVolumeSummaryByPeriod", //Data Volume Trends
			// *** Search:  ***
			"IOT_GetStateList",
			"IOT_GetSimTypes",
			// *** Sim Details: ***
			// "GetHssProfiles", // leave these out for now
			// "getHlrProfiles", // causes issues in PROD
			// "IOT_GetSimUsage",
			// "IOT_GetImeiData",
			// "IOT_GetCurrentUsage",
			"IOT_ViewMapDataByImsi",
			"IOT_GetDataBucketList",
			// "IOT_GetSimInfo",
			"IOT_TopOffPlans",
			"getDslDataPlans",
			"IOT_GetGroupList", //for admin section
		];
		if (cached_methods.includes(method)) {
			//&& !url.includes('nocache=1')) || url.includes('nocache=0')) {
			let current = Date.now(); //(((date.getHours() * 3600) + date.getMinutes() * 60) + date.getSeconds());
			let cache = sessionStorage.getItem(params);
			let expiry = sessionStorage.getItem(params + "_expiry");
			if (
				cache &&
				!JSON.stringify(cache).toLowerCase().includes("fail") &&
				!JSON.stringify(cache).toLowerCase().includes("error") &&
				!JSON.stringify(cache).toLowerCase().includes("exception") &&
				cache.length > 15 &&
				expiry &&
				expiry > current &&
				!expireCache
			) {
				if (process.env.NODE_ENV === "dev") console.warn("[DEBUG][commonAPI][response_cache]", cache);
				return Promise.resolve(JSON.parse(cache));
			}
		}
		//remove the item from cache (if exists)
		sessionStorage.removeItem(params);
		sessionStorage.removeItem(params + "_expiry");

		//get from remote
		return Vue.axios
			.get(url, headers, {timeout: ws_timeout})
			.then(response => {
				if (typeof response === "undefined") {
					let e = new Error("Request Failed due to network error. Response is undefined.");
					e.name = "NETWORK_ERROR";
					throw e;
				} else if (JSON.stringify(response).includes("Missing Authentication Token")) {
					let e = new Error("Request Failed, Endpoint request timed out, Missing Authentication Token");
					e.name = "API_ERROR";
					throw e;
				} else if (
					JSON.stringify(response).includes("PDOException") &&
					!url.includes("IOT_GetSubscriberLogs")
				) {
					let e = new Error("Request Failed. Database PDOException. Status Code: 500");
					e.name = "API_ERROR";
					this.showToast(
						"Request Failed. Database PDOException. Status Code: 500. Please contact support@dccllc.net"
					);
					throw e;
				} else if (
					JSON.stringify(response).includes("Connection timed out") &&
					!url.includes("IOT_GetSubscriberLogs")
				) {
					let e = new Error("Request Failed. Connection timed out. Status Code: 500");
					e.name = "API_ERROR";
					throw e;
				} else if (JSON.stringify(response).includes("Endpoint request timed out")) {
					let e = new Error("Request Failed. Endpoint request timed out. Status Code: 500");
					e.name = "API_ERROR";
					throw e;
				} else if (JSON.stringify(response).includes("Request Failed")) {
					let e = new Error("Request Failed. Status Code: 400");
					e.name = "API_ERROR";
					throw e;
				} else if (JSON.stringify(response).includes("Internal server error")) {
					let e = new Error("Request Failed. Internal Server Error.");
					e.name = "API_ERROR";
					throw e;
				} else if (!response.hasOwnProperty("data") || !response.data.hasOwnProperty("message")) {
					let e = new Error("Request Failed. No data in message.");
					e.name = "API_ERROR";
					throw e;
				} else {
					if (JSON.stringify(response).includes("FAIL") && !JSON.stringify(response).includes("IOT_Logout")) {
						//{"data":{"status":true,"message":"FAIL - PDOException:
						if (process.env.NODE_ENV === "dev") console.error("API Response Contains Error: ", response);
					}
					//only store if it is in the cached methods
					if (cached_methods.includes(method)) {
						let new_expiry = Date.now() + 14400000; //((((date.getHours() + 4) * 3600) + date.getMinutes() * 60) + date.getSeconds());
						sessionStorage.setItem(params + "_expiry", new_expiry.toString());
						sessionStorage.setItem(params, JSON.stringify(response));
					}
					return response;
				}
			})
			.catch(e => {
				if (process.env.NODE_ENV === "dev") console.warn("[DEBUG][commonAPI][error]", e);
				if (retry < 1) {
					if (process.env.NODE_ENV === "dev")
						console.warn("API_RETRY[" + retry + "]" + url + " - " + e.message);
					Bugsnag.leaveBreadcrumb(`Retried method: ${params} - ${e.message}`);
					return this.commonAPI(params, retry + 1);
				} else {
					if (process.env.NODE_ENV === "dev")
						console.error("API_FAILURE[" + retry + "]:--------------------------", url, e);
					let msg = `NOTICE: An API request failed [${method}].
          If this problem continues Please contact DCC.
          Error Details: ${e.message}
          URL: ${url}`;
					// this.sendPortalErrorEmail(msg);
					if (!e.message.includes("No data in message")) {
						this.showToast(msg);
						Bugsnag.notify(e);
					} else {
						console.warn("Bugsnag notify skipped: No data in message");
					}

					return {data: {message: "FAIL - API Request Failed.", error_details: e.message}};
				}
			});
	},

	// Moved to main.js
	// startBugsnag() {
	//   // Bugsnag.start({
	//   //   apiKey: process.env.VUE_APP_BUGSNAG_TOKEN,
	//   //   releaseStage: process.env.NODE_ENV,
	//   //   appVersion: process.env.VUE_APP_UX_VERSION,
	//   //   redactedKeys: [
	//   //     /^auth$/i, // case-insensitive
	//   //     /^key$/i, // case-insensitive: "key", "KEY", "KeY"
	//   //     "access_token", // exact match: "access_token"
	//   //     /^password$/i, // case-insensitive: "password", "PASSWORD", "PaSsWoRd"
	//   //     /^cc_/, // prefix match: "cc_number" "cc_cvv" "cc_expiry"
	//   //   ],
	//   //   onError: function (event) {
	//   //     let user = initService.getCustomerUser();
	//   //     //configure the bugsnag user identification
	//   //     event.setUser('3', user.email, user.username);
	//   //     //set the site settings
	//   //     event.addMetadata('site-settings', res);
	//   //     //configure click events as required.
	//   //     Bugsnag.leaveBreadcrumb(this.$route.query);
	//   //   },
	//   // });
	//   // Bugsnag.beforeNotify = function (data) {
	//   //   if (
	//   //     !location.toString().toLowerCase().includes("localhost") &&
	//   //     process.env.NODE_ENV.toString().toLowerCase().includes("prod")
	//   //   ) {
	//   //     data.metaData.sessionURL = LogRocket.sessionURL;
	//   //   }
	//   //   return data;
	//   // };
	// },

	// Replaced by Bugsnag
	// async sendPortalErrorEmail(error) {
	//   // TODO Need to replace EMAIL_TO after testing;
	//   // let param = `IOT_SendEmailMessage&To=${supportUser}&Subject={CLIENT} Portal Error&Body= ${msg}`;
	//   let email_to = "jdoe@example.com";
	//   let email_subject = encodeURIComponent(process.env.VUE_APP_CLIENT + " PORTAL ERROR NOTIFICATION");
	//   let email_body = encodeURIComponent(JSON.stringify(error));
	//   let baseUrl = `${process.env.VUE_APP_CONFIG_BASEURL}`;
	//   //remove undefined
	//   if (baseUrl.includes('/undefined')) baseUrl = baseUrl.replace('/undefined', '');
	//   let param = `${baseUrl}?method=IOT_SendEmailMessage&email_to=${email_to}&email_subject=${email_subject}&email_body=${email_body}`;
	//   Vue.axios.get(param, headers).then(res => {
	//     if (process.env.NODE_ENV === "dev") console.warn(res, "-<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<");
	//   });
	// },

	parseJsonToHtml(jsonData) {
		//console.log('parseJsonToHtml:', jsonData);
		//try: npm install json2html
		// const json2html = require('node-json2html')
		// var htmlTable = json2html.transform(jsonData, template);

		if (!jsonData || typeof jsonData === "undefined") return "<b>Error:</b> No Data Response";
		else if (typeof jsonData["HSS"] !== "undefined" && typeof jsonData["HSS"]["success"] !== "undefined") {
			jsonData = jsonData["HSS"]["success"];
		}
		var prettyHtml = require("json-pretty-html").default;
		var htmlTable = prettyHtml(jsonData);
		//remove the curley brackets and backslash
		let html = htmlTable.toString();
		html = html
			.replaceAll("\\", "")
			.replaceAll("&nbsp;", "")
			.replaceAll('"', "")
			.replaceAll("{", "")
			.replaceAll("}", "")
			.replaceAll("[", "")
			.replaceAll("]", "")
			.replaceAll("json-pretty", '"json-pretty"')
			.replaceAll("json-key", '"json-key"')
			.replaceAll("json-string", '"json-string"')
			.replaceAll("<br>,<br>", ",<br>")
			.replaceAll('<span class="json-key">output</span>:<br>', "");
		//console.log('parseJsonToHtml:',html);
		//return the data...
		return html;
	},

	showToast(msg, title = "API Failure Warning", type = "warning") {
		if (msg.includes("IOT_AddInventory")) {
			return false;
		} else {
			Vue.$toast[type]({
				component: ToastVue,
				props: {
					title: "",
					description: msg,
					subtitle: title,
				},
			});
		}
	},

	commonErrorHandling(e, method = "undefined") {
		if (typeof e === "undefined") {
			e = new Error("Request Failed. Error: undefined");
			e.name = "UNDEFINED_ERROR";
		}

		console.error(`[commonErrorHandling][${method}]`, e);

		let testBugsnag = false;
		if (process.env.NODE_ENV.toString().toLowerCase().includes("prod")) {
			console.log("PROD");
			Bugsnag.notify(e);
		} else if (testBugsnag) {
			console.log("Bugsnag Test Running");
			Bugsnag.notify(e);
		}
	},

	checkOnlineStatusEvent() {
		//ERROR HANDLER FOR ONLINE STATUS
		setInterval(async () => {
			var d = new Date();
			const result = await checkOnlineStatus();
			if (result) {
				//online
			} else {
				//offline
				if (process.env.NODE_ENV === "dev") console.log("User browser OFFLINE..." + String(d));
				swal.fire({
					title: "ERROR",
					html: "<small>You appear to be offline preventing updates from the server.  Would you like to reload this page?</small>",
					showCancelButton: true,
					confirmButtonText: "Reload",
					cancelButtonText: "Cancel",
				}).then(result => {
					//debugger;
					if (result.dismiss === swal.DismissReason.cancel) {
						if (process.env.NODE_ENV === "dev") console.log("User did not reload page.");
					} else {
						if (process.env.NODE_ENV === "dev") console.log("User reloaded page.");
						window.location.reload(false);
					}
				});
			}
			//const statusDisplay = document.getElementById("status");
			//statusDisplay.textContent = result ? "Online" : "OFFline";
		}, 45000); // probably too often, try 45000 for every 45 seconds

		const checkOnlineStatus = async () => {
			try {
				let refBaseUrl = "/";
				const online = await fetch(refBaseUrl + "?" + Math.random());
				return online.status >= 200 && online.status < 300; // either true or false
			} catch (err) {
				return false; // definitely offline
			}
		};
	},

	validationCheck(inputField = "", inputValue = "", inputValueTwo = 0) {
		//NOTE: old code is deprecated in favor of new method.
		//return this.validateData(inputField, inputValue, inputValueTwo);
		//console.log('validationCheck inputField:',inputField,' inputValue:',inputValue);
		//validators https://www.npmjs.com/package/node-input-validator or https://express-validator.github.io/docs/
		//https://regex101.com/codegen?language=javascript
		let res = false;
		let reg = /^[0-9]$/gm;
		switch (inputField) {
			case "ICCID":
				reg = /^[0-9]{20}$/gm;
				res = reg.test(inputValue);
				break;

			case "IMSI":
				reg = /^[0-9]{15}$/gm;
				res = reg.test(inputValue);
				break;

			case "MSISDN":
				reg = /(^\d{11}$)|(^\d{15}$)/gm;
				res = reg.test(inputValue);
				break;

			case "MIN":
				reg = /(^\d{10}$)/gm;
				res = reg.test(inputValue);
				break;

			case "SUBSCRIBERNAME":
				//reg = /^[\w_]{3,50}/gm;
				//res = reg.test(inputValue);
				res = inputValue.length > 3 && inputValue.length < 51;
				break;

			case "HSSPROFILE":
				reg = /[A-Za-z\d]{3,50}/;
				res = reg.test(inputValue);
				res = String(inputValue).length > 0; //override this
				break;

			case "HLRPROFILE":
				reg = /[A-Za-z\d]{3,50}/;
				res = String(inputValue).length > 0; //override this
				break;

			case "DATAPLAN":
				reg = /[A-Za-z\d]{3,50}/;
				res = reg.test(inputValue);
				break;

			default:
				res = String(inputValue).length > 0; //override this
				break;
		}
		//console.log('validation: ',res);
		return res;
	},

	unixToDate(unixDateStr, format = "YYYY/MM/DD hh:mm:ss") {
		return moment.unix(unixDateStr).format(format);
	},

	dateToInt(dateStr) {
		return new Date(dateStr).getTime();
	},

	strToDate(dateStr, format = "YYYY/MM/DD hh:mm:ss") {
		return moment(dateStr).format(format);
	},

	stringToUuid(str) {
		str = str.replace("-", "");
		return "xxxxxxxx-xxxx-4xxx-xxxx-xxxxxxxxxxxx".replace(/[x]/g, function (c, p) {
			return str[p % str.length];
		});
	},

	getLastKey(strVal, splitter = ".", replaceVal = " ", properCase = true) {
		let val = strVal
			.split(splitter)
			.pop()
			.match(/[A-Z]+(?![a-z])|[A-Z]?[a-z]+|\d+/g)
			.join(replaceVal);
		if (properCase) {
			val = this.toProperCase(val);
		}
		return val;
	},

	toProperCase(s) {
		return s.toLowerCase().replace(/^(.)|\s(.)/g, function ($1) {
			return $1.toUpperCase();
		});
	},

	refreshPage() {
		//window.location.reload();
		this.$forceUpdate();
	},

	showToasterMsg(message, append = false, variant = "success") {
		//setup for alert
		let myTemplate = `
      <div>
        <h2 class="text-white">Notification:</h2>
        <p class="text-white">${message}</p>
      </div>
    `;
		this.$toast.error(myTemplate, {type: variant});
	},

	formatPhone(str) {
		try {
			let res = `${str}`;
			res = res
				.replace(/\D/g, "")
				.replace(/^(\d{3})(\d{3})(\d{4})/g, "$1-$2-$3")
				.replace(/^(\d{3})(\d{3})(\d*)/g, "$1-$2-$3")
				.replace(/^(\d{3})(\d{1,3})/g, "$1-$2")
				.replace(/^(\d{1,3})/g, "$1")
				.substring(0, 12)
				.trim();
			//console.log('formatter: ', res);
			return res;
		} catch (e) {
			//console.error(e);
			return str;
		}
	},

	/**
	 * Validate an inputField against regex
	 * @param inputField
	 * @param inputData
	 * @returns {boolean|RegExp}
	 */
	validateData(inputField, inputData, inputDataTwo = 0) {
		//console.log('validateData::inputField:',inputField)
		//console.log('validateData::inputData:',inputData)
		let isValid = false;
		switch (String(inputField).toLowerCase()) {
			case "iccid":
				isValid = /^\d{20}$/.test(inputData);
				break;
			case "imsi":
				isValid = /^\d{15}$/.test(inputData);
				break;
			case "pin1":
				isValid = /^\d{4}$/.test(inputData);
				break;
			case "pin2":
				isValid = /^\d{4}$/.test(inputData);
				break;
			case "acc":
				isValid = /^\d{4,8}$/.test(inputData);
				break;
			case "puk1":
				isValid = /^\d{6,8}$/.test(inputData);
				break;
			case "puk2":
				isValid = /^\d{6,8}$/.test(inputData);
				break;
			case "adm1":
				isValid = /^\d{8}$/.test(inputData);
				break;
			case "opc":
				if (inputData === "") {
					isValid = true; //it is ok to have a null string
					break;
				}
				isValid = /^([a-zA-Z0-9_-]){32}$/.test(inputData);
				break;
			case "psk":
				isValid = /^([a-zA-Z0-9_-]){64}$/.test(inputData);
				break;
			case "tls":
				isValid = /^([a-zA-Z0-9_-]){64}$/.test(inputData);
				break;
			case "ki":
				isValid = /^([a-zA-Z0-9_-]){32}$/.test(inputData);
				break;
			case "kic":
				isValid = /^([a-zA-Z0-9_-]){32}$/.test(inputData);
				break;
			case "kik":
				isValid = /^([a-zA-Z0-9_-]){32}$/.test(inputData);
				break;
			case "kid":
				isValid = /^([a-zA-Z0-9_-]){32}$/.test(inputData);
				break;
			case "dek":
				isValid = /^([a-zA-Z0-9_-]){32}$/.test(inputData);
				break;
			case "msisdn":
				if (inputData === "") {
					isValid = true; //it is ok to have a null string
					break;
				}
				isValid = /^[0-9]{11}$/.test(inputData);
				if (!isValid) {
					inputData = inputData.replace(/\D/g, "");
					isValid = /^[0-9]{10,11}$/.test(inputData);
				}
				break;
			case "min":
				isValid = /^[0-9]{10}$/.test(inputData);
				break;
			case "mdn":
				isValid = /^[0-9]{10}$/.test(inputData);
				break;
			case "subscribername":
				isValid = /^[A-Za-z0-9]{3,50}$/.test(inputData);
				break;
			case "hssprofile":
				isValid = /[A-Za-z\d]{3,50}/.test(inputData);
				break;
			case "hlrprofile":
				isValid = /[A-Za-z\d]{3,50}/.test(inputData);
				break;
			case "dataplan":
				isValid = /[A-Za-z\d]{3,50}/.test(inputData);
				break;
			case "vendor":
				isValid =
					"default,gemalto,simulity,simulitylte,esim,unitedesim".indexOf(String(inputData).toLowerCase()) >
					-1;
				break;
			case "eprl":
				isValid = String(inputData).length > 3;
				break;
			case "oplmn":
				isValid = String(inputData).length > 3;
				break;
			case "fplmn":
				isValid = String(inputData).length > 3;
				break;
			case "operator":
				isValid = String(inputData).length > 3;
				break;
			case "customer":
				isValid = String(inputData).length > 3;
				break;
			case "carrier":
				isValid = String(inputData).length > 3;
				break;
			case "status":
				isValid = String(inputData).length > 3;
				break;
			case "product":
				isValid = String(inputData).length > 3;
				break;

			default:
				isValid = false; //note: we don't know the type so no error.
				break;
		}
		//console.log('validateData:',isValid);
		return isValid;
	},

	//validator example:  https://bytutorial.com/blogs/vuejs/custom-form-validation-with-vuejs

	lowercaseObjKeys(obj) {
		return Object.keys(obj).reduce((acc, key) => {
			acc[key.toLowerCase()] = obj[key];
			return acc;
		});
	},

	ConvertKeysToLowerCase(obj) {
		var output = {};
		for (i in obj) {
			if (Object.prototype.toString.apply(obj[i]) === "[object Object]") {
				output[i.toLowerCase()] = ConvertKeysToLowerCase(obj[i]);
			} else if (Object.prototype.toString.apply(obj[i]) === "[object Array]") {
				output[i.toLowerCase()] = [];
				output[i.toLowerCase()].push(ConvertKeysToLowerCase(obj[i][0]));
			} else {
				output[i.toLowerCase()] = obj[i];
			}
		}
		return output;
	},

	OtaMapImportKeys(obj) {
		let output = {};
		let newKey = "";
		for (i in obj) {
			switch (i.toLowerCase()) {
				case "iccid":
					newKey = "iccid";
					break;
				case "msisdn":
					newKey = "msisdn";
					break;
				case "mdn":
					newKey = "mdn";
					break;
				case "min":
					newKey = "min";
					break;
				case "eprl":
					newKey = "eprl";
					break;
				case "fplmn":
					newKey = "fplmn";
					break;
				case "oplmn":
					newKey = "oplmn";
					break;
				case "tls":
					newKey = "tls";
					break;
				case "kic":
					newKey = "kic";
					break;
				case "kid":
					newKey = "kid";
					break;
				case "vendor":
					newKey = "vendor";
					break;
				case "#iccid#":
					newKey = "iccid";
					break;
				case "var_out:#iccid#":
					newKey = "iccid";
					break;
				case "#psk#":
					newKey = "tls";
					break;
				case "#kic#":
					newKey = "kic";
					break;
				case "#kid#":
					newKey = "kid";
					break;
				default:
					newKey = "REMOVE_ME";
					break;
			}
			if (newKey !== "REMOVE_ME" && newKey !== "") {
				output[newKey] = obj[i];
			}
		}
		let keys = "iccid,tls,kic,kid";
		keys.split(",").forEach(key => {
			if (key === "vendor" && !output["vendor"]) output["vendor"] = "default";
			if (!output[key]) output[key] = key + " MISSING";
		});
		return output;
	},

	EsimMapImportKeys(obj) {
		let output = {};
		let newKey = "";
		for (i in obj) {
			switch (
				i
					.toLowerCase()
					.replaceAll("#", "")
					.replaceAll("dp", "p")
					.replaceAll("da", "a")
					.replaceAll("var_out:", "")
			) {
				case "iccid":
					newKey = "iccid";
					break;
				case "pin1":
					newKey = "pin1";
					break;
				case "pin2":
					newKey = "pin2";
					break;
				case "puk1":
					newKey = "puk1";
					break;
				case "puk2":
					newKey = "puk2";
					break;
				case "kid":
					newKey = "kid";
					break;
				case "imsi":
					newKey = "imsi";
					break;
				case "imsi1":
					newKey = "imsi";
					break;
				case "msisdn":
					newKey = "msisdn";
					break;
				case "ki":
					newKey = "ki";
					break;
				case "opc":
					newKey = "opc";
					break;
				case "psk":
					newKey = "psk";
					break;
				case "tls":
					newKey = "tls";
					break;
				case "adm":
					newKey = "adm1";
					break;
				case "adm1":
					newKey = "adm1";
					break;
				case "kic":
					newKey = "kic";
					break;
				case "kik":
					newKey = "kik";
					break;
				case "dek":
					newKey = "dek";
					break;
				case "acc":
					newKey = "acc";
					break;
				default:
					newKey = "";
					break;
			}
			if (newKey !== "") {
				output[newKey.toUpperCase()] = obj[i];
			}
		}
		let keys = "ICCID,PIN1,PIN2,PUK1,PUK2,KID,IMSI,KI,OPC,PSK,ADM1,KIC,KIK,DEK,ACC";
		keys.split(",").forEach(key => {
			if (key === "KIK" && !output["KIK"] && output["KID"]) output["KIK"] = output["KID"];
			if (key === "DEK" && !output["DEK"] && output["KID"]) output["DEK"] = output["KID"];
			//if (!output[key]) output[key] = key + " MISSING";
		});
		return output;
	},

	NewEsimMapImportKeys(obj) {
		let output = {};
		let newKey = "";
		for (i in obj) {
			switch (
				i
					.toLowerCase()
					.replaceAll("#", "")
					.replaceAll("dp", "p")
					.replaceAll("da", "a")
					.replaceAll("var_out:", "")
			) {
				case "iccid":
					newKey = "iccid";
					break;
				case "pin1":
					newKey = "pin1";
					break;
				case "pin2":
					newKey = "pin2";
					break;
				case "puk1":
					newKey = "puk1";
					break;
				case "puk2":
					newKey = "puk2";
					break;
				case "kid":
					newKey = "kid";
					break;
				case "imsi":
					newKey = "imsi";
					break;
				case "imsi1":
					newKey = "imsi";
					break;
				case "msisdn":
					newKey = "msisdn";
					break;
				case "ki":
					newKey = "ki";
					break;
				case "opc":
					newKey = "opc";
					break;
				case "psk":
					newKey = "tls";
					break;
				case "tls":
					newKey = "tls";
					break;
				case "adm":
					newKey = "adm1";
					break;
				case "adm1":
					newKey = "adm1";
					break;
				case "kic":
					newKey = "kic";
					break;
				case "kik":
					newKey = "kik";
					break;
				case "dek":
					newKey = "dek";
					break;
				case "acc":
					newKey = "acc";
					break;
				// case "eki":
				//   newKey = "eki";
				//   break;
				// case "eopc":
				//   newKey = "eopc";
				//   break;
				// case "tk":
				//   newKey = "tk";
				//   break;
				default:
					newKey = "";
					break;
			}
			if (newKey !== "") {
				output[newKey] = obj[i];
			}
		}
		let keys = "iccid,pin1,pin2,puk1,puk2,kid,imsi,ki,opc,tls,adm1,kic,kik,dek,acc"; //,eki,eopc,tk";
		keys.split(",").forEach(key => {
			if (key === "kik" && !output["kik"] && output["kik"]) output["kik"] = output["kik"];
			if (key === "dek" && !output["dek"] && output["dek"]) output["dek"] = output["dek"];
			if (!output[key]) output[key] = "";
		});
		return output;
	},

	InventoryMapImportKeys(obj) {
		let output = {};
		let newKey = "";
		for (i in obj) {
			switch (
				i
					.toLowerCase()
					.replaceAll("#", "")
					.replaceAll("dp", "p")
					.replaceAll("da", "a")
					.replaceAll("var_out:", "")
			) {
				case "iccid":
					newKey = "ICCID";
					break;
				case "pin1":
					newKey = "PIN1";
					break;
				case "pin2":
					newKey = "PIN2";
					break;
				case "puk1":
					newKey = "PUK1";
					break;
				case "puk2":
					newKey = "PUK2";
					break;
				case "kid":
					newKey = "kid";
					break;
				case "imsi":
					newKey = "IMSI";
					break;
				case "imsi1":
					newKey = "IMSI";
					break;
				case "msisdn":
					newKey = "MSISDN";
					break;
				case "ki":
					newKey = "Ki";
					break;
				case "opc":
					newKey = "opc";
					break;
				case "operator":
					newKey = "operator";
					break;
				case "customer":
					newKey = "customer";
					break;
				case "status":
					newKey = "status";
					break;
				case "product":
					newKey = "product";
					break;
				default:
					newKey = "";
					break;
			}
			if (newKey !== "") {
				output[newKey] = obj[i];
			}
		}
		let keys = "ICCID,PIN1,PIN2,PUK1,PUK2,kid,operator,Ki,IMSI,opc,MSISDN,customer,status,product";
		keys.split(",").forEach(key => {
			//Operator,Customer,status,product
			let carrier = process.env.VUE_APP_CLIENT;
			if (key === "operator" && !output[key]) output[key] = carrier;
			if (key === "customer" && !output[key]) output[key] = carrier;
			if (key === "status" && !output[key]) output[key] = "Inventory";
			if (key === "product" && !output[key]) output[key] = "none";
			if (key === "MSISDN" && !output[key]) output[key] = "";
			if (key === "opc" && !output[key]) output[key] = "";
			else if (!output[key] && key !== "MSISDN") output[key] = key + " MISSING";
		});
		return output;
	},

	iccidDecoder(iccid) {
		//https://onomondo.com/resource-hub/iccid-number-explained/
		//IAIN (Individual Account Identification Number)
		//ICCID = MII + CC + IIN + IAIN          + C
		//ICCID = 89  + 01 + 29  + 0170228018596 + 8
		//ICCID = 89  + 01 + 29  + 0170228018596 + 8
		// MSIN = The unique number that identifies the subscriber
		// IMSI = MCC + MNC + MSIN
		// IMSI = 312 + 290 + 001013596
		// MCCMNC = 312 290
		// encode = 130 292
	},

	decodeImsi(imsi) {
		let swapped = "";
		//imsi = this.bin2hex(this.base64_decode(imsi));
		let list = this.str_split(imsi, 2);
		list.forEach(rj => {
			swapped += this.strrev(rj);
		});
		swapped = this.substr(swapped, 3);
		return swapped;
	},

	str_split(string, splitLength) {
		//  discuss at: https://locutus.io/php/str_split/
		// original by: Martijn Wieringa
		// improved by: Brett Zamir (https://brett-zamir.me)
		// bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
		//  revised by: Theriault (https://github.com/Theriault)
		//  revised by: Rafał Kukawski (https://blog.kukawski.pl)
		//    input by: Bjorn Roesbeke (https://www.bjornroesbeke.be/)
		//   example 1: str_split('Hello Friend', 3)
		//   returns 1: ['Hel', 'lo ', 'Fri', 'end']
		if (splitLength === null) {
			splitLength = 1;
		}
		if (string === null || splitLength < 1) {
			return false;
		}
		string += "";
		const chunks = [];
		let pos = 0;
		const len = string.length;
		while (pos < len) {
			chunks.push(string.slice(pos, (pos += splitLength)));
		}
		return chunks;
	},

	strrev(s) {
		return s.split("").reverse().join("");
	},

	substr(str, len) {
		return str.substr(len);
	},
};

export default commonService;
